import { VisitCardV2 } from './visit-card-v2';
import { VisitState, VisitStatus } from 'store/visits/types';
import { InfiniteScrollContainer } from '../shared/infinite-scroll-container';

interface VisitsCardListV2Props {
  visits: VisitState[];
  isLoading?: boolean;
  buildingId?: string;
  after?: string;
  before?: string;
}

const renderSkeletonCards = (count: number) =>
  Array.from({ length: count }, (_, index) => <VisitCardV2 key={`skeleton-${index}`} isLoading />);

export const VisitsCardListV2 = ({
  visits,
  isLoading = false,
  buildingId,
  after,
  before,
}: VisitsCardListV2Props): JSX.Element => (
  <div className="flex flex-col gap-4">
    {isLoading ? (
      renderSkeletonCards(2)
    ) : (
      <InfiniteScrollContainer buildingId={buildingId} after={after} before={before}>
        {visits.map((visitState) => {
          if (!visitState.data) {
            return null;
          }
          const visit = visitState.data;

          return (
            <VisitCardV2
              key={visit.id}
              id={visit.id}
              first_name={visit.first_name}
              last_name={visit.last_name}
              visit_status={visit.status || visit.visit_status || VisitStatus.INVITED}
              arrival_date={visit.arrival_date}
              departure_date={visit.departure_date}
              floor={visit.floor}
              suite={visit.suite}
              host={visit.host}
              frequency={visit.frequency}
              recurrence_days={visit.recurrence_days}
              end_date={visit.end_date}
              count={visit.count}
              monthly_mode={visit.monthly_mode}
              monthly_on_last_day={visit.monthly_on_last_day}
              monthly_by_day={visit.monthly_by_day}
              vendor_company_uuid={visit.vendor_company_uuid}
              is_group_visit={visit.is_group_visit}
            />
          );
        })}
      </InfiniteScrollContainer>
    )}
  </div>
);
